import { ReactElement } from "react";
import { Outlet } from "react-router-dom";

import "./main-page.scss";
import Header from "../header/header";
import SideBar from "../sidebar/sidebar.component";

const MainPage: React.FC = (): ReactElement => {
  return (
    <div className="main-page-container flex flex-col overflow-y-auto overflow-x-hidden">
      <Header />
      <div className="main-content flex">
        <SideBar />
        <div className="content flex flex-col p-2 md:p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainPage;
